export const API_NAME = 'billingapi'
